import { PACKAGE_VERSION } from '../package-version.js';
export const constructClientAgents = (clientAgents = []) => {
    const instantMeilisearchAgent = `Meilisearch instant-meilisearch (v${PACKAGE_VERSION})`;
    return clientAgents.concat(instantMeilisearchAgent);
};
//# sourceMappingURL=agents.js.map